export const WISESHEETS_API_URL = 'https://api.wisesheets.io'
export const demoTickers = ['AAPL', 'AMZN', 'TSLA']
export const demoFundTickers = ['SPY', 'IYE', 'PICK']
